module.exports = __webpack_public_path__ + "static/img/fukuan.053bd05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/fukuan.png
// module id = 7J4i
// module chunks = 171